import { isMdmEnrollPath } from 'router/routes';
import { getEnvironment } from 'utils/_utils/environment';

// Imports here are deliberately minimal: both `router/routes` and `utils/_utils/environment` are
// import-free leaves. Reaching for the `utils/utils` barrel instead would drag in `_utils/misc`, which
// imports `api`, putting a cycle in front of the module-level constants below.

const DEFAULT_API_BASE = import.meta.env.VITE_API_URL! + import.meta.env.VITE_API_VERSION;
const DEFAULT_MEDIA_BASE = (import.meta.env.VITE_API_URL! as string).replace('api/', 'media/logos');

/** Trailing slashes are stripped so `baseURL + '/auth/token'` never double-slashes. */
const parseBase = (value?: string): { base: string; origin: string } | null => {
  const trimmed = value?.trim();
  if (!trimmed) return null;

  try {
    return { base: trimmed.replace(/\/+$/, ''), origin: new URL(trimmed).origin };
  } catch {
    // A malformed value must degrade to the normal base rather than break the page.
    return null;
  }
};

// Apple MDM enrollment is the only flow where the page is opened by the device being enrolled rather
// than by a browser inside our network, so it is the only flow that needs the DEV backend's public
// certificate proxy. All three conditions are required, and each one alone keeps rc/prod on the normal
// base: `.env.production` never defines the variable and the rc/prod CI jobs pass no matching
// --build-arg, so the value and the environment check rule it out independently.
const isDevEnvironment = ['dev', 'local'].includes(getEnvironment());

const appleEnrollDevProxy =
  isDevEnvironment && isMdmEnrollPath(window.location.pathname)
    ? parseBase(import.meta.env.VITE_SECURITY_CHECK_SERVICE_MOBILE_REACHABLE_BASE)
    : null;

export const API_BASE_URL = appleEnrollDevProxy?.base ?? DEFAULT_API_BASE;

// The default partner logos live on the same host as the API, so the pre-login enrollment screen would
// otherwise render a broken image on a device that cannot resolve the usual DEV API host.
export const MEDIA_BASE_URL = appleEnrollDevProxy ? `${appleEnrollDevProxy.origin}/media/logos` : DEFAULT_MEDIA_BASE;
